import { PiggyBank } from "lucide-react";
import { eur } from "../../lib/shield";

const e = (c) => eur(c || 0).replace(".00", "");
export const raisedText = (f) => `${e(f?.amount)} raised from ${f?.shields || 0} shield${f?.shields === 1 ? "" : "s"}`;

export const FundsSummary = ({ funds }) => (
  <section className="border-2 border-lime-500 bg-slate-900 p-5 text-white shadow-[6px_6px_0_0_#a3e635]" data-testid="coach-funds-summary">
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <PiggyBank className="h-9 w-9 text-lime-300" />
        <div>
          <div className="text-xs font-bold uppercase tracking-wider text-slate-400">To be paid to your club</div>
          <div className="font-display text-4xl font-black leading-none text-lime-300" data-testid="coach-funds-total">{e(funds?.net)}</div>
        </div>
      </div>
      <div className="text-sm text-slate-300" data-testid="coach-funds-shields">from {funds?.shields || 0} shield{funds?.shields === 1 ? "" : "s"} sold through your squad links</div>
    </div>
    <div className="mt-4 grid grid-cols-3 gap-2 border-t border-slate-700 pt-3 text-center text-sm" data-testid="coach-funds-breakdown">
      <div><div className="text-xs text-slate-400">Funds raised</div><div className="font-bold" data-testid="coach-funds-raised">{e(funds?.amount)}</div></div>
      <div><div className="text-xs text-slate-400">− Club delivery</div><div className="font-bold" data-testid="coach-funds-delivery">{e(funds?.delivery)}</div></div>
      <div><div className="text-xs text-slate-400">= Paid to club</div><div className="font-bold text-lime-300" data-testid="coach-funds-net">{e(funds?.net)}</div></div>
    </div>
  </section>
);
